import React, { useEffect, useRef, InputHTMLAttributes } from 'react';
import { useField } from '@unform/core';
import { Container, CheckBoxWrapper, CheckBox, CheckBoxLabel } from './styles';

interface Props {
  name: string;
  label?: string;
}

type InputProps = InputHTMLAttributes<HTMLInputElement> & Props;

export default function Switch({ name, label, ...rest }: InputProps) {
  const inputRef = useRef<HTMLInputElement>({} as HTMLInputElement);
  const { fieldName, defaultValue, registerField, error } = useField(name);

  const defaultChecked = defaultValue;

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef,
      getValue: ref => {
        return ref.current.checked;
      },
      clearValue: ref => {
        /**
         * If you want to change the default checked for false or true,
         * you can do so here. In this example, when resetting the form,
         * the checkbox goes back to its initial state.
         */
        ref.current.checked = defaultChecked;
      },
      setValue: (ref, value) => {
        ref.current.checked = value;
      },
    });
  }, [defaultValue, fieldName, registerField, defaultChecked]);

  return (
    <Container>
      <CheckBoxWrapper>
        <CheckBox
          defaultChecked={defaultValue}
          ref={inputRef}
          type="checkbox"
          id={fieldName}
          {...rest}
        />

        <CheckBoxLabel htmlFor={fieldName} key={fieldName}>
          {label}
        </CheckBoxLabel>

        {error && <span>{error}</span>}
      </CheckBoxWrapper>
    </Container>
  );
}
